module.exports = __webpack_public_path__ + "img/icon-weixin.30a2b5f7.png";